module.exports = __webpack_public_path__ + "img/aws_acm.371b76e4.jpg";